export const seoContent = {
  home: {
    title: 'Truck Parking Hub | Secure & Affordable',
    description: 'Find secure, gated truck parking with flexible daily, weekly, and monthly rates. Reserve your parking spot online.',
    section: 'Home',
  },
  locations: {
    title: 'Truck Parking Locations | Truck Parking Hub',
    description: 'Browse secure truck parking locations and reserve your spot with easy highway access and gated facilities.',
    section: 'Locations',
  },
  rates: {
    title: 'Truck Parking Rates | Flexible Daily, Weekly, Monthly Plans',
    description: 'Compare truck parking rates and savings across daily, weekly, and monthly plans.',
    section: 'Rates',
  },
  ...(process.env.REACT_APP_DISABLE_FEATURE !== 'true'
    ? {
        pm_partners: {
          title: 'PM Service Partners | Truck Parking Hub',
          description: 'Connect with trusted truck maintenance and repair partners from the Truck Parking Hub PM partner network.',
          section: 'PM Partners',
        },
      }
    : {}),
  about: {
    title: 'About Truck Parking Hub',
    description: 'Learn about Truck Parking Hub and our mission to provide secure, affordable truck parking.',
    section: 'About',
  },
};
